import { SET_ACCOUNT_DATA } from "./actionType";

const init = {
  UserName: "",
  Roles: [],
  fetched: false,
};

export default function reducer(state = init, action) {
  switch (action.type) {
    case SET_ACCOUNT_DATA: {
      action.payload = action.payload || init;
      return {
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
